// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".test-hover[data-v-167015b0]:hover {\n  background-color: rgba(211, 95, 95, 0.4196078431);\n}", ""]);
// Exports
module.exports = exports;
